import { APP_LOYALTY_PREFIX_PATH } from "configs/AppConfig";

export const ROUTES = {
  HOME: `${APP_LOYALTY_PREFIX_PATH}/home`,
  REWARDS: `${APP_LOYALTY_PREFIX_PATH}/rewards`,
  PROFILE: `${APP_LOYALTY_PREFIX_PATH}/profile`,
  PROFILE_REWARDS: `${APP_LOYALTY_PREFIX_PATH}/profile-rewards`,
  PROFILE_MEMBERSHIPS: `${APP_LOYALTY_PREFIX_PATH}/profile-memberships`,
  PROFILE_LEVEL: `${APP_LOYALTY_PREFIX_PATH}/level`,
  PROFILE_ACTIVITY: `${APP_LOYALTY_PREFIX_PATH}/activities`,
  MEMBERSHIPS: `${APP_LOYALTY_PREFIX_PATH}/memberships`,
  MEMBERSHIP_DETAILS: `${APP_LOYALTY_PREFIX_PATH}/membership-details/%s`,
  CHECKOUT: `${APP_LOYALTY_PREFIX_PATH}/checkout/%s`,
  APPOINTMENT_DETAILS: `${APP_LOYALTY_PREFIX_PATH}/appointments`,
  BOOKING: `${APP_LOYALTY_PREFIX_PATH}/booking`,
  DOCTORS: `${APP_LOYALTY_PREFIX_PATH}/doctors`,
  SERVICES: `${APP_LOYALTY_PREFIX_PATH}/services`,
  INFO: `${APP_LOYALTY_PREFIX_PATH}/info`,
  CONSENT_FORMS: `${APP_LOYALTY_PREFIX_PATH}/consent-forms`,
  CONSENT_FORM_VIEW: `${APP_LOYALTY_PREFIX_PATH}/consent-forms/view`,
};
